export default __webpack_public_path__ + "static/latitude-card-lockup-268d8dbe3a2880ad22e5b719ea6ea04c.webp";